import { Link } from "react-router";
import styled from "styled-components";
import Seo from "./Seo";
import PageHeading from "./PageHeading";
import { PageContainer } from "./sharedStyleds";
import { notFoundMeta } from "./routeMeta";

// What a visitor sees when a URL does not exist.
//
// Netlify already answers 404 for these - public/_redirects for any unknown
// path, and the edge function for an explorer id that cannot be an address -
// and serves build/404.html, which is this page prerendered. The status was
// right and the page was not: the app booted, matched the URL against its own
// routes, and either redirected to the home page or rendered an empty wallet
// lookup titled after the id. So a 404 arrived saying "Page not found" and then
// replaced itself with something that claimed to be a page.
//
// The words come from routeMeta.js, which the prerender step reads too, so the
// served HTML and the rendered page say the same thing.

const Note = styled.p`
  max-width: 75ch;
  color: #a3abba;
`;

const Ways = styled.ul`
  margin-top: 0.4rem;
`;

const Wayfinder = styled(Link)`
  color: #62c4ff;
`;

const NotFound = ({ note }) => (
  <PageContainer>
    <Seo {...notFoundMeta} path="/404" noindex />
    <PageHeading meta={notFoundMeta} />
    {note && <Note>{note}</Note>}
    <Ways>
      <li>
        <Wayfinder to="/">Bitcoin Live</Wayfinder> — transactions and blocks as
        they happen
      </li>
      <li>
        <Wayfinder to="/btc-explorer">BTC Explorer</Wayfinder> — look up an
        address or a transaction
      </li>
      <li>
        <Wayfinder to="/btc-explorer/exchanges">Notable wallets</Wayfinder> —
        exchange cold storage, government seizures, known whales
      </li>
    </Ways>
  </PageContainer>
);

export default NotFound;
